<!-- Header / Navigation Bar -->
<header class="bg-white border-b border-[#E6E6E6] sticky top-0 z-50 px-4 lg:px-8 py-3.5">
  <div class="max-w-[1280px] mx-auto flex items-center justify-between">

    <!-- Logo -->
    <div class="flex items-center gap-2">

      <span class="text-[#BE2F27] text-[22px] font-[700] tracking-tight">bucca</span>
      <span class="text-[#E6E6E6] text-[18px]">|</span>
      <span class="text-[#344054] text-[15px] font-[600] tracking-wide uppercase">{{ organisationName }}</span>
    </div>

    <!-- Navigation Links (Desktop) -->
    <nav class="hidden md:flex items-center gap-[32px]">
      <button (click)="switchView('home')"
        [ngClass]="currentView === 'home' ? 'text-[#BE2F27] border-b-2 border-[#BE2F27] font-[600]' : 'text-[#667085] hover:text-[#344054] border-b-2 border-transparent font-[500]'"
        class="py-2 text-[14px] transition-all cursor-pointer flex">
        <span class="mr-2"><img src="home-smile.svg" alt=""></span> Home
      </button>
      <button (click)="switchView('bookings')"
        [ngClass]="currentView === 'bookings' ? 'text-[#BE2F27] border-b-2 border-[#BE2F27] font-[600]' : 'text-[#667085] hover:text-[#344054] border-b-2 border-transparent font-[500]'"
        class="py-2 text-[14px] transition-all cursor-pointer flex">
        <span class="mr-2"><img src="shopping-cart-03.svg" alt=""></span> Bookings
      </button>
      <button (click)="switchView('profile')"
        [ngClass]="currentView === 'profile' ? 'text-[#BE2F27] border-b-2 border-[#BE2F27] font-[600]' : 'text-[#667085] hover:text-[#344054] border-b-2 border-transparent font-[500]'"
        class="py-2 text-[14px] transition-all cursor-pointer flex">
        <span class="mr-2"><img src="user-02.svg" alt=""></span> Account
      </button>

    </nav>

    <!-- Right Section Actions -->
    <div class="flex items-center gap-3 lg:gap-5">

      <!-- Cart Action -->
      <button (click)="toggleCart()"
        class="relative bg-[#BE2F27] hover:bg-[#A8251E] text-white flex items-center gap-2 p-[8px_16px] rounded-lg transition-all cursor-pointer shadow-sm">
        <!-- Cart Icon SVG -->
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        <span class="font-[600] text-[14px]">{{ cartQuantity }}</span>
      </button>

      <!-- User Profile Avatar and Dropdown Info (Desktop) -->
      <button (click)="switchView('profile')"
        class="hidden sm:flex items-center gap-3 border-l border-[#E6E6E6] pl-5 cursor-pointer hover:opacity-85 transition-all focus:outline-none bg-transparent border-0 text-left">
        <div
          class="w-[36px] h-[36px] rounded-[6px] bg-[#F3F3F3] text-[#121212] flex items-center justify-center font-[700] text-[14px]">
          {{ initials }}
        </div>
        <div class="text-left leading-tight flex items-center gap-1.5">
          <div>
            <p class="text-[14px] font-[600] text-[#121212] m-0">{{ userName }}</p>
            <p class="text-[12px] font-[500] text-[#667085] m-0">Staff</p>
          </div>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            class="text-gray-400 mt-0.5">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </button>

      <!-- Logout Button (Desktop) -->
      <button (click)="logout.emit()"
        class="hidden sm:flex items-center justify-center p-2 text-gray-500 hover:text-[#BE2F27] transition-colors cursor-pointer"
        title="Logout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </button>

      <!-- Mobile Menu Toggle -->
      <button (click)="mobileMenuOpen = !mobileMenuOpen"
        class="md:hidden p-2 text-gray-500 hover:text-black cursor-pointer">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>
    </div>

  </div>

  <!-- Mobile Dropdown Navigation -->
  <div *ngIf="mobileMenuOpen" class="md:hidden mt-4 border-t border-[#E6E6E6] pt-3 flex flex-col gap-3">
    <button (click)="switchView('home')" [class.text-[#121212]]="currentView === 'home'"
      class="text-left py-2 px-3 text-[14px] font-[600] text-[#344054] hover:bg-gray-50 rounded-lg cursor-pointer">
      Home
    </button>
    <button (click)="switchView('bookings')" [class.text-[#121212]]="currentView === 'bookings'"
      class="text-left py-2 px-3 text-[14px] font-[600] text-[#344054] hover:bg-gray-50 rounded-lg cursor-pointer">
      Bookings
    </button>
    <button (click)="switchView('transactions')" [class.text-[#121212]]="currentView === 'transactions'"
      class="text-left py-2 px-3 text-[14px] font-[600] text-[#344054] hover:bg-gray-50 rounded-lg cursor-pointer">
      Transactions
    </button>

    <button (click)="logout.emit()"
      class="text-left py-2 px-3 text-[14px] font-[600] text-[#F04438] hover:bg-red-50 rounded-lg cursor-pointer">
      Logout
    </button>
    <button (click)="switchView('profile')"
      class="w-full border-t border-[#E6E6E6] pt-3 px-3 flex items-center gap-3 cursor-pointer hover:bg-gray-50 rounded-lg transition-colors focus:outline-none bg-transparent border-0 text-left">
      <div
        class="w-[36px] h-[36px] rounded-[6px] bg-[#F3F3F3] text-[#121212] flex items-center justify-center font-[400] text-[14px]">
        {{ initials }}
      </div>
      <div class="text-left">
        <p class="text-[13px] font-[600] text-[#121212] m-0">{{ userName }}</p>
        <p class="text-[11px] font-[500] text-[#667085] m-0">Staff Member</p>
      </div>
    </button>
  </div>
</header>